import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import 'rxjs/add/operator/switchMap';

import { AuthService } from './auth.service';
import { TimeService } from '../shared/services/time.service';

import { SharedClientService } from '../components/client/shared/services/shared-client.service';


export class TimezoneGuardService implements CanActivate {

	constructor(
		private authService: AuthService,
		private timeService: TimeService,
		private sharedClientService: SharedClientService) { }

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		let appTimezone = this.timeService.appTimezone;

		if (appTimezone !== null) {
			// Already set
			return Observable.of(true);
		}

		if (this.authService.isLoggedIn && this.authService.userType === 'client') {
			return this.sharedClientService.get(this.authService.userId)
				.switchMap(
					(client) => {
						this.timeService.setAppTimezone(client.timezone);

						return Observable.of(true);
					}
				);
		} else {
			this.timeService.setFallbackTimezone();

			return Observable.of(true);
		}
	}
static ctorParameters() { return [ { type: AuthService }, { type: TimeService }, { type: SharedClientService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/providers/timezone-guard.service.ts